module.exports = __webpack_public_path__ + "static/media/great-staff.0243c60f.svg";